import {
	ADD_USER_IN_HIERARCHY,
	REMOVE_USER_FROM_HIERARCHY,
	ADD_PENDING_USER,
	REMOVE_PENDING_USER,
	UPDATE_USER_STATUS,
	CONNECT,
	DISCONNECT,
	APPEND_USER_LIST,
} from '../actions/types';

const initialState = {
	usersInRoom: [],
	pendingUsers: [],
	connected: false,
};

export default function (state = initialState, action) {
	// Ensure pendingUsers is always an array for safety
	const safePendingUsers = Array.isArray(state.pendingUsers)
		? state.pendingUsers
		: [];
	const safeUsersInRoom = Array.isArray(state.usersInRoom)
		? state.usersInRoom
		: [];

	switch (action.type) {
		case APPEND_USER_LIST:
			return {
				...state,
				usersInRoom: action.payload || [],
			};
		case ADD_USER_IN_HIERARCHY:
			return {
				...state,
				usersInRoom: [...safeUsersInRoom, action.payload],
			};
		case REMOVE_USER_FROM_HIERARCHY:
			return {
				...state,
				usersInRoom: safeUsersInRoom.filter(
					(user) => user._id !== action.payload
				),
			};
		case ADD_PENDING_USER:
			console.log('➕ ADD_PENDING_USER reducer:', {
				payload: action.payload,
				currentPendingUsers: safePendingUsers,
				newUser: action.payload
			});
			
			const newPendingUsers = [...safePendingUsers, action.payload];
			console.log('➕ Updated pending users array:', newPendingUsers);
			
			return {
				...state,
				pendingUsers: newPendingUsers,
			};
		case REMOVE_PENDING_USER:
			return {
				...state,
				pendingUsers: safePendingUsers.filter(
					(user) => user._id !== action.payload
				),
			};
		case UPDATE_USER_STATUS:
			console.log('🔄 UPDATE_USER_STATUS reducer:', {
				payload: action.payload,
				pendingUsers: safePendingUsers,
				userIdToUpdate: action.payload.userId
			});
			
			const updatedPendingUsers = safePendingUsers.map((user) => {
				const matches = user._id === action.payload.userId;
				console.log('🔄 User comparison:', {
					user_id: user._id,
					target_id: action.payload.userId,
					matches: matches
				});
				
				return matches
					? {
							...user,
							status: action.payload.status,
							isPending: false,
						}
					: user;
			});
			
			console.log('🔄 Updated pending users:', updatedPendingUsers);
			
			return {
				...state,
				pendingUsers: updatedPendingUsers,
			};
		case CONNECT:
			return {
				...state,
				connected: true,
			};
		case DISCONNECT:
			return {
				...state,
				connected: false,
			};
		default:
			return state;
	}
}
